import { Inbox } from "lucide-react";
import { SECTOR_LABELS } from "../constants";
import { RecipientActions } from "../hooks/use-recipients-source";
import { SECTOR_EMAILS_LABELS } from "../messages";
import { SectorRecipient } from "../types";
import { RowActions } from "./row-actions";
import { ShippingTypeBadges } from "./shipping-type-badges";

interface RecipientCardsProps {
  recipients: SectorRecipient[];
  actions: RecipientActions;
}

export function RecipientCards({
  recipients,
  actions,
}: RecipientCardsProps): JSX.Element {
  if (recipients.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 rounded-lg border border-gray-200 bg-white px-6 py-16 text-center text-muted-foreground md:hidden">
        <Inbox className="h-8 w-8" />
        {SECTOR_EMAILS_LABELS.EMPTY_STATE}
      </div>
    );
  }

  return (
    <div className="space-y-3 md:hidden">
      {recipients.map((recipient: SectorRecipient) => (
        <div
          key={recipient.id}
          className={`space-y-3 rounded-lg border border-gray-200 bg-white p-4 shadow-sm ${
            recipient.active ? "" : "opacity-50"
          }`}
        >
          <div className="flex items-start justify-between gap-2">
            <div>
              <p className="font-medium text-gray-900">
                {recipient.name || "—"}
              </p>
              <p className="text-xs text-gray-500">{recipient.email}</p>
            </div>
            <span className="shrink-0 text-xs text-gray-500">
              {SECTOR_LABELS[recipient.sector]}
            </span>
          </div>

          <ShippingTypeBadges types={recipient.shipping_types} />

          <RowActions recipient={recipient} actions={actions} />
        </div>
      ))}
    </div>
  );
}
